import * as React from 'react';
import EventEmitter from 'eventemitter3';
import {
  MODAL_HIDE,
  MODAL_SHOW,
  ModalComponent,
  ModalComponentProps,
} from './ModalManager';
export const eventEmitter = new EventEmitter();

/**
 * Zobrazení modálního dialogu. Pokud je nějaký dialog zobrazen, zobrazí se nad ním další.
 *
 * @param component reference na komponentu
 * @param componentProps props, které budou předávány při renderování komponenty
 *
 * @returns {{type: string, component: *, componentProps: *}}
 */
export const show = (
  component: ModalComponent,
  componentProps?: ModalComponentProps
) => {
  eventEmitter.emit(MODAL_SHOW, {
    component,
    componentProps,
  });
};

export const showWaiting = <T,>(
  waitingPromise: Promise<T>,
  component: ModalComponent,
  componentProps?: ModalComponentProps
): Promise<T> => {
  return new Promise(function (resolve, reject) {
    show((props: any) => {
      waitingPromise
        .then((data: T) => {
          props.onClose();
          // @ts-ignore
          resolve(data);
        })
        .catch((error: any) => {
          props.onClose();
          reject(error);
        });
      return React.createElement(component, {
        ...props,
      });
    }, componentProps);
  });
};

/**
 * Zavření aktuálního dialogu. Pokud je jich otevřeno více, zavře se poslední otevřený.
 */
export const hide = () => {
  eventEmitter.emit(MODAL_HIDE, {});
};

export const Modal = {
  show,
  showWaiting,
  hide,
};
